import Tool, { type ToolArgs } from '../../../tools/Tool';
import { Transforms } from 'slate';
import TableUtils from '../TableUtils';

class ToolTableNumberedRowToggle extends Tool {
  static toolName = 'Numbered rows';
  static iconClass = 'fa-regular fa-list-ol';

  static action({ editor }: ToolArgs): void {
    if (!editor.selection) return;

    const tableEntry = TableUtils.currentTable(editor);
    if (!tableEntry) return;

    if (tableEntry[0].table_numberedRows) {
      Transforms.unsetNodes(editor, ['table_numberedRows'], {
        at: tableEntry[1],
      });
    } else {
      Transforms.setNodes(
        editor,
        { table_numberedRows: true },
        {
          at: tableEntry[1],
        }
      );
    }
  }

  static isActive({ editor }: ToolArgs): boolean {
    if (!editor?.selection) return false;

    const tableElement = TableUtils.currentTableElement(editor);
    if (!tableElement) return false;

    return Boolean(tableElement.table_numberedRows);
  }

  static isEnabled({ editor }: ToolArgs): boolean {
    if (!editor?.selection) return false;

    const tableElement = TableUtils.currentTableElement(editor);
    if (!tableElement) return false;

    return true;
  }
}

export default ToolTableNumberedRowToggle;
